import { render, staticRenderFns } from "./Supports.vue?vue&type=template&id=1818dcd2&scoped=true&"
import script from "./Supports.vue?vue&type=script&lang=js&"
export * from "./Supports.vue?vue&type=script&lang=js&"
import style0 from "./Supports.vue?vue&type=style&index=0&id=1818dcd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818dcd2",
  null
  
)

export default component.exports